import React, { useRef, memo } from 'react';

const TeeCard = memo((props) => {
    // const { book, onBookSelect, isBookingAllowed, isBookingInProgress, restrictedTemplateID } = props;
    const { book, onBookSelect, isBookingAllowed, isBookingInProgress } = props;

    // useRef is synchronous — survives re-renders without stale-closure risk
    const isClickingRef = useRef(false);

    const handleClick = async () => {
        if (isClickingRef.current || isBookingInProgress) return;
        isClickingRef.current = true;
        try {
            await onBookSelect(book);
        } finally {
            isClickingRef.current = false;
        }
    };

    return (<>
        <div className="col-md-6 col-sm-6 col-lg-3 padding-0" >
            <div className={`slot-card ${((!!book.Status && book.Status != 'Cancelled') || !!isBookingAllowed || isBookingInProgress || !book?.isSessionOpen ) && 'disableClick'}`}
            // <div className={`slot-card ${((!!book.Status && book.Status != 'Cancelled') || !!isBookingAllowed || isBookingInProgress || !book?.isSessionOpen || restrictedTemplateID == book?.TemplateID) && 'disableClick'}`}
                onClick={handleClick}
            >
                <div className={`${
                // (restrictedTemplateID == book?.TemplateID) ? 'slot-card-header-restricted' :
                    (!book.Status) ? 'slot-card-header' :
                        (book.Status == 'Pending') ? 'slot-card-header-pending' :
                            (book.Status == 'Cancelled') ? 'slot-card-header-cancel' :
                                (book.Status == 'FCFS') ? 'slot-card-header-fcfs' :
                                    'slot-card-header-blur'
                    }`}>
                    <div className="row margin-0">
                        <div className="col-xs-12 padding-0">
                            <b> {book.Slot} </b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
});


export default TeeCard;
